export type ItemType = 'image' | 'gallery' | 'video' | 'video-gallery';

/** Derives the display type of an item from the kinds of its ordered media. */
export function deriveItemType(media: ReadonlyArray<{ kind: 'image' | 'video' }>): ItemType {
  const videos = media.filter((m) => m.kind === 'video').length;
  const images = media.length - videos;
  if (videos > 0) return images > 0 || videos > 1 ? 'video-gallery' : 'video';
  return images > 1 ? 'gallery' : 'image';
}
